import React from 'react'
import { Card, CardContent } from 'components/Card'
import { observer } from 'mobx-react'
import cx from 'classnames'

import { BookkeepingManagerActionFilter } from 'admin/bookkeeping/BookkeepingManagerSearchViewModel'
import { SingleSelectFilter } from 'infra/FilterControls/SingleSelect/SingleSelectFilter'

import styles from './BookkeepingManagerActionFilter.sass'

interface BookkeepingManagerActionFilterProps<
  TFilters extends Record<string, unknown>,
> {
  filter: SingleSelectFilter<keyof TFilters, BookkeepingManagerActionFilter>
}

export default observer(function BookkeepingManagerActionFilter<
  TFilters extends Record<string, unknown>,
>({ filter }: BookkeepingManagerActionFilterProps<TFilters>) {
  return (
    <div className={styles.root}>
      <h1 className={styles.title}>{filter.title}</h1>
      <div className={styles.cardsContainer}>
        {filter.options.map((opt) => (
          <BookkeepingManagerFilterCard
            key={opt.value.type}
            title={opt.title}
            option={opt.value}
            filter={filter}
          />
        ))}
      </div>
    </div>
  )
})

interface BookkeepingManagerFilterCardProps<
  TFilters extends Record<string, unknown>,
> {
  title: string
  option: BookkeepingManagerActionFilter
  filter: SingleSelectFilter<keyof TFilters, BookkeepingManagerActionFilter>
}

const BookkeepingManagerFilterCard = observer(
  function BookkeepingManagerFilterCard<
    TFilters extends Record<string, unknown>,
  >({ title, option, filter }: BookkeepingManagerFilterCardProps<TFilters>) {
    return (
      <button
        className={cx(
          styles.filterCardContainer,
          filter.value.type === option.type && styles.active,
        )}
        onClick={() => filter.change(option)}
        data-test={`bookkeeping-manager-action-filter-card-${option.type}`}
      >
        <Card borderless>
          <CardContent compact>
            <div
              className={cx(
                styles.filterCardContent,
                styles[`requestVariant-${option.type}`],
              )}
            >
              <h2 className={styles.countTitle}>{title}</h2>
              <h1 className={styles.countTotal}> {option.count}</h1>
            </div>
          </CardContent>
        </Card>
      </button>
    )
  },
)
